import { navigateToPage } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';

import { trackClickNext } from './tracking';
import { getDataPaymentFormUrl } from '../../utils/getDataPaymentFormUrl';
import { mapPageTypeToAnalytics } from '../../utils/getPageviewObject';
import { mapEstimationTargetToCategory } from '../../constants/filters';

export const openDataPaymentForm = (): TThunkAction => {
  return (dispatch, getState) => {
    const {
      page: { deviceType, pageType },
      filters,
    } = getState();

    const { url, queryString } = getDataPaymentFormUrl({
      address: filters.address,
      houseId: filters.houseId,
      roomsCount: filters.roomsCount,
      totalArea: filters.area,
    });

    trackClickNext({
      deviceType,
      queryString,
      address: filters.address,
      area: filters.area,
      roomsCount: filters.roomsCount,
      category: mapPageTypeToAnalytics[pageType],
    });

    navigateToPage(url);
  };
};

export const openSuburbanDataPaymentForm = (): TThunkAction => {
  return (dispatch, getState) => {
    const {
      page: { deviceType, pageType },
      filters,
    } = getState();
    const { estimationTarget } = filters;

    const { url, queryString } = getDataPaymentFormUrl({
      address: filters.address,
      houseId: filters.houseId,
      houseArea: filters.houseArea,
      landArea: filters.landArea as number,
      category: mapEstimationTargetToCategory[estimationTarget],
    });

    trackClickNext({
      deviceType,
      queryString,
      address: filters.address,
      category: mapPageTypeToAnalytics[pageType],
      houseArea: filters.houseArea,
      landArea: filters.landArea,
    });

    navigateToPage(url);
  };
};
